module.exports = __webpack_public_path__ + "static/media/search-icon-sidebar.59efed18.svg";